import { useCallback } from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { CircleDoneIcon, colors, usePressable } from '@pletly/ui';
import { TeamInfo, BasicTeam } from '../../../../../../screens/components/TeamInfo';

type Props<Team extends BasicTeam> = {
	team: Team;
	isSelected: boolean;
	onPress: (teamUuid: string, isSelected: boolean) => void;
};

export const TeamSelectRow = <Team extends BasicTeam>({
	isSelected,
	onPress,
	team,
}: Props<Team>) => {
	const { isHovered, onHoverIn, onHoverOut } = usePressable();

	const handleTeamPress = useCallback(() => {
		onPress(team.uuid, isSelected);
	}, [onPress, team.uuid, isSelected]);

	return (
		<Pressable
			onHoverIn={onHoverIn}
			onHoverOut={onHoverOut}
			key={`team-${team.uuid}`}
			style={[styles.flexRow, styles.row, isHovered && styles.hovered]}
			onPress={handleTeamPress}
		>
			<TeamInfo team={team} />
			<CircleDoneIcon selected={isSelected} />
		</Pressable>
	);
};

const styles = StyleSheet.create({
	flexRow: {
		flexDirection: 'row',
	},
	row: {
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: 8,
	},
	hovered: {
		backgroundColor: colors.neutral,
	},
});
